<template>
    <transition name="el-fade-in-linear">
        <el-container v-show="pageShow">
            <el-header class="sj_navbar_fixed">
                <Header :active="2"></Header>
            </el-header>
            <el-main class="sj_main">
                <div class="sj_container">
                    <div class="sj_breadcrumb">
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                            <el-breadcrumb-item>PBL智慧教室</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                    <el-row :gutter="50">
                        <el-col :md="24" :lg="12">
                            <img class="sj_img" src="../../assets/class/class_2.jpg"/>
                        </el-col>
                        <el-col :md="24" :lg="12">
                            <div class="sj_content">
                                <h2>PBL智慧教室</h2>
                                <div class="sj_line"></div>
                                <p>尚哲PBL智慧教室解决方案，结合PBL教学特点，通过计算机、多媒体、物联设备和网络，提供分组研讨、分组汇报、教师指导等教学应用场景，支持多屏互动、互动教学、课程录播等丰富的功能，由传统课堂教师为主体转换以学生为中心，改变“我讲你听，我做你看”的教学方法，极大调动学生学习主动性，营造良好的课堂氛围。支持基于问题的精英教学的教学开展，以问题、学习者、合作学习为中心的教学模式。</p>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="sj_content_title">
                        <h2 class="title">更多类型</h2>
                        <div class="subtitle"><div class="sj_line"></div></div>
                    </div>
                    <el-row :gutter="30">
                        <el-col :xs="24" :md="12" :lg="8" v-for="(item,index) in listClass" :key="index">
                            <div class="sj_content_more" @click="jump(item.router)">
                                <el-image class="sj_img" :src="item.src" @load="handleImg" @error="handleError">
                                    <div slot="placeholder" class="image-slot">
                                        加载中<span class="dot">...</span>
                                    </div>
                                    <div slot="error" class="image_error">图片加载失败</div>
                                </el-image>
                                <div class="title">{{item.name}}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-main>
            <el-footer>
                <Footer></Footer>
            </el-footer>
        </el-container>
    </transition>
</template>

<script>
  import Header from "../../components/Header";
  import Footer from "../../components/Footer";

  export default {
    components: {
      Header,
      Footer
    },
    data() {
      return {
        type: "",
        pageShow: false,
        listClass:[
          {src:require('../../assets/class/class_sm_7.jpg'),name:'标准智慧教室',router:'c7'}
          ,{src:require('../../assets/class/class_sm_1.jpg'),name:'TBL智慧教室',router:'c1'}
          ,{src:require('../../assets/class/class_sm_3.jpg'),name:'微格智慧教室',router:'c3'}
          ,{src:require('../../assets/class/class_sm_4.jpg'),name:'电教智慧教室',router:'c4'}
          ,{src:require('../../assets/class/class_sm_5.jpg'),name:'阶梯智慧教室',router:'c5'}
          ,{src:require('../../assets/class/class_sm_6.jpg'),name:'工业机器人智慧实训基地',router:'c6'}
        ]
      };
    },
    methods:{
      //跳转页面
      jump(name) {
        this.$nextTick(function () {
          this.$router.push({ name: name })
        })
      },
      handleImg() {
        this.pageShow = true;
      },
      handleError(){
        this.pageShow = true;
      }
    }
  };
</script>

<style scoped lang="scss">
    .sj_line {
        margin-top: 20px;
    }
    .sj_content_more{
        margin-bottom: 30px;
        cursor: pointer;
        .title{
            line-height: 50px;
            background: #376ACB;
            color: #ffffff;
            font-size: $fontsize_base;
            text-indent: 20px;
        }
    }
</style>
